import React from 'react'
import { useSelector } from "react-redux";
import { pddServiceLine} from "../../utils/defaultValues";
import { Navigate } from "react-router-dom";

function PddProjectScopeWrapper({children}) {
      const scope = useSelector((state) => state.container.scope);
    
      const validateProjectScope = () => {
        return (scope.isProjectScope && scope.serviceLine.toLowerCase() === pddServiceLine.name.toLowerCase() && !!scope.projectIdent)
      }
      
      return validateProjectScope() ? (
        children
      ) : (
        <Navigate to={`${pddServiceLine.root}/project-list`} replace />
      );
    };

export default PddProjectScopeWrapper
